var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-disclaimer text-bold"},[_vm._v("Disclaimer: Spend and cost amounts displayed are based on the price of the click and not the actual amount billed/invoiced.")])
}
var staticRenderFns = []

export { render, staticRenderFns }